var React = require('react');

function AsteriskInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#181A1B","fillRule":"nonzero"},React.createElement("g",null,React.createElement("path",{"d":"M13.029 46L12.602 37.665 19.935 42.174 22 38.826 14.097 35 22 31.174 19.935 27.826 12.602 32.472 13.029 24 8.9 24 9.398 32.472 2.065 27.826 0 31.174 7.832 35 0 38.826 2.065 42.174 9.398 37.596 8.9 46z","transform":"translate(-165 -611) translate(165 587)"})))));
}

AsteriskInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = AsteriskInline;

AsteriskInline.default = AsteriskInline;
